import lax from "lax.js";

export class LaxAnimations {
  lax;

  constructor() {
    lax.init();

    lax.addDriver("scrollY", () => window.scrollY, {
      inertiaEnabled: true,
    });
    window.lax = lax;
    this.lax = lax;

    this.laxAnimations();
  }

  laxAnimations() {
    const animationClasses = [
      "fade-in",
      "fade-up",
      "fade-up-long",
      "fade-down",
      "fade-right",
      "fade-left",
      "fade-up-right",
      "fade-up-left",
      "zoom-in",
      "zoom-in-up",
    ];

    const selector = animationClasses.map((cls) => "." + cls).join(", ");
    const animatedElements = document.querySelectorAll(selector);

    const pageLoadedTime = new Date().getTime();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const observedTime = new Date().getTime();

            if (observedTime === pageLoadedTime) {
              setTimeout(() => {
                this.animateElement(entry.target);
              })
            } else {
              this.animateElement(entry.target);
            }
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.15,
      }
    );

    animatedElements.forEach((element) => {
      observer.observe(element);
    });
  }

  animateElement(element) {
    // Default is no delay
    let delay = 0;

    // Check for delay classes
    const delayClass = Array.from(element.classList).find((cls) => cls.startsWith("lax-delay-"));
    if (delayClass) {
      const delayValue = delayClass.replace("lax-delay-", "");
      const parsedDelay = parseInt(delayValue, 10);
      if (!isNaN(parsedDelay)) {
        delay = parsedDelay;
      }
    }

    setTimeout(() => {
      if (element && element.isConnected) {
        element.style.opacity = "1";
        element.style.transform = "none";
      }
    }, delay);
  }
}
